export const app = {
  'App Vialaser': 'App Vialaser',
  'The Vialaser app in the palm of your hand':
    'Vialaser en la palma de tu mano',
  'Download the app and have full control of your laser hair removal treatments — wherever you are.':
    'Descargá la app y tené control total de tus tratamientos de depilación láser, estés donde estés.',
  'We are a network of clinics focused on laser hair removal. We created the app to give you more autonomy and convenience to handle everything from your phone, without needing to call or visit a clinic.':
    'Somos una red de clínicas enfocada en depilación láser. Creamos la app para darte más autonomía y comodidad para resolver todo desde tu celular, sin necesidad de llamar o ir hasta la unidad.',
  'Everything you need, in your pocket':
    'Todo lo que necesitás, en tu bolsillo',
  'Session scheduling': 'Agendamiento de sesión',
  'Book, reschedule or cancel your session in a few taps.':
    'Agendá, reprogramá o cancelá tu sesión en pocos toques.',
  'Online store': 'Tienda online',
  'Buy packages and products directly through the app.':
    'Comprá paquetes y productos directamente desde la app.',
  'Financial control': 'Control financiero',
  'Keep track of payments and installments of your treatments.':
    'Seguí los pagos y cuotas de tus tratamientos.',
  'Session reminders': 'Recordatorio de sesión',
  'Get notified so you never miss your session.':
    'Recibí notificaciones para no perderte tu sesión.',
  'Convenience that fits in your pocket': 'Comodidad que cabe en tu bolsillo',
  'Everything you need to manage your treatments is one tap away.':
    'Todo lo que necesitás para gestionar tus tratamientos está a un toque de distancia.',
  'Vialaser app home screen preview':
    'Vista previa de la pantalla de inicio de la app Vialaser',
};
